import { Box, Modal } from "@mui/material";

const ModalContainer = ({ openModal, setOpenModal, colors, children }) => {
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        backgroundColor={colors.primary[400]}
        color={colors.primary[100]}
        width="600px"
        borderRadius="5px"
        textAlign="center"
        m="auto"
        p="20px"
      >
        {children}
      </Box>
    </Modal>
  )
}

export default ModalContainer
